import styled from 'styled-components';
import { CommonTitle } from '../../components/items/common.title';
import { FileUploadImg } from '../../components/items/uploadImg';
import { useHistory, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { carNoSchema, companyUploadImgSchema } from '../../schema/mypageSchema';
import { Button } from '../../components/items/Button';
import { useState } from 'react';
import { AlertModal } from '../../components/modal/alert.modal';
import {
  uploadCompanyRegistration,
  uploadVehicleRegistration,
} from '../../api/join';
import {
  companyUpdateRegistration,
  updateRegistration,
} from '../../api/mypage';
import { useRecoilValue } from 'recoil';
import { authState } from '../../atoms/authState';

interface CarFormValue {
  registrationFile: File | null;
}

const CarRegistrationChange = () => {
  const auth = useRecoilValue(authState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [navigateOnClose, setNavigateOnClose] = useState(false); // 페이지 이동 여부를 추적
  const history = useHistory();

  const schema =
    auth.userType === 'driver' ? carNoSchema : companyUploadImgSchema;

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<CarFormValue>({
    resolver: zodResolver(schema),
  });

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (navigateOnClose) {
      history.push({
        pathname: '/mypage',
      }); // navigateOnClose가 true일 때만 /mypage로 이동
    }
  };

  const onSubmit = async (data: CarFormValue) => {
    try {
      if (data.registrationFile) {
        // 1. 파일 업로드

        let registrationUrl;
        if (auth.userType === 'driver') {
          registrationUrl = await uploadVehicleRegistration(
            data.registrationFile,
          );
        } else {
          registrationUrl = await uploadCompanyRegistration(
            data.registrationFile,
          );
        }

        console.log(registrationUrl);
        // 2. 업로드된 파일 URL을 사용하여 DB 업데이트
        // 2. 업로드된 파일 URL을 사용하여 DB 업데이트
        let response;

        if (auth.userType === 'driver') {
          // 유저가 차주일 경우
          response = await updateRegistration(registrationUrl);
        } else {
          // 유저가 회사일 경우
          response = await companyUpdateRegistration(registrationUrl);
        }

        if (response.statusCode === 200) {
          setModalMessage(response.message);
          setNavigateOnClose(true); // 성공 시 페이지 이동 설정
        } else {
          setModalMessage('자동차 등록증 변경에 실패했습니다.');
          setNavigateOnClose(false);
        }
      } else {
        setModalMessage('파일을 선택해주세요.');
        setNavigateOnClose(false);
      }
    } catch (error) {
      console.error('자동차 등록증 변경 실패:', error);
      setModalMessage('자동차 등록증 변경 중 오류가 발생했습니다.');
      setNavigateOnClose(false);
    } finally {
      setIsModalOpen(true);
    }
  };

  return (
    <Container>
      <CommonTitle
        title={
          auth.userType === 'driver'
            ? '자동차 등록증 변경'
            : '사업자 등록증 변경'
        }
        subTitle={
          auth.userType === 'driver'
            ? '자동차 등록증을 선택해주세요. \n(jpg, gif, png)'
            : '사업자 등록증을 선택해주세요. \n(jpg, gif, png)'
        }
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <FileUploadImg
          title={
            auth.userType === 'driver'
              ? '자동차 등록증 첨부하기'
              : '사업자 등록증 첨부하기'
          }
          height="200"
          name="registrationFile"
          register={register}
          setValue={setValue}
          errors={
            errors.registrationFile?.message
              ? [errors.registrationFile.message as string]
              : []
          }
        />
        <Button type="submit" title="변 경" fiexd />
      </form>
      {isModalOpen && (
        <AlertModal
          handleConfirmClose={handleModalClose}
          confirmText={modalMessage}
          onClick={handleModalClose} // 회원가입 완료 시에만 로그인 화면으로 이동
        />
      )}
    </Container>
  );
};

export default CarRegistrationChange;

const Container = styled.div`
  padding: 2.4rem 2rem;
`;
